import { fieldRequired } from "./helpers"

export const optionRequired = fieldRequired
